import React from "react";

function Symptoms() {
  return (
    <>
      <section className="faq position-relative ps pb-0">
        <div className="container">
          <div className="text-center">
            <h2 className="hadding mb-4 color3 text-center  ">
              Your symptoms are signals.
              <br /> We decode them for you.{" "}
            </h2>
            <p className=" mb-md-4 mb-3 ">
              Identify the key areas to enhance your health span
            </p>
          </div>
          <ul className="signals_ul position-relative">
            <li className="cs_case_study active signals_ul_li1">
              <h3>
                <img
                  src="/assets/img/signal/frame.png"
                  className="small_img"
                  alt=""
                />{" "}
                Fatigue &amp; Low Energy{" "}
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/fatigue.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  We screen genetic markers (mitochondrial function, vitamin
                  deficiencies) and metabolic data (thyroid, glucose) to uncover
                  why energy drops.
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li2">
              <h3>
                {" "}
                <img
                  src="/assets/img/signal/insomnia.png"
                  className="small_img"
                  alt=""
                />{" "}
                Poor Sleep &amp; Insomnia
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/insomnia.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  Circadian rhythm genes, cortisol load, and recovery biomarkers
                  reveal why your sleep cycles are disrupted
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li3">
              <h3>
                {" "}
                <img
                  src="/assets/img/signal/anxiety.png"
                  className="small_img"
                  alt=""
                />{" "}
                Stress &amp; Anxiety
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/anxiety.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  Dopamine/serotonin pathway variants plus HRV and cortisol
                  markers show how your body handles stress and how to improve
                  resilience
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li4">
              <h3>
                {" "}
                <img
                  src="/assets/img/signal/unwanted.png"
                  className="small_img"
                  alt=""
                />{" "}
                Unwanted Weight Gain
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/unwanted.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  We decode FTO/MC4R genes, metabolic efficiency, and hormonal
                  imbalances that contribute to stubborn weight
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li5">
              <h3>
                {" "}
                <img
                  src="/assets/img/signal/digestive.png"
                  className="small_img"
                  alt=""
                />{" "}
                Digestive Issues &amp; Bloating
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/digestive.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  Gut-related genes (lactose, gluten sensitivity) and
                  microbiome-linked markers highlight digestive inefficiencies
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li6">
              <h3>
                {" "}
                <img
                  src="/assets/img/signal/skin.png"
                  className="small_img"
                  alt=""
                />{" "}
                Skin &amp; Hair Problems
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/skin.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  Collagen breakdown genes, oxidative stress, and nutrient
                  deficiencies reveal why skin and hair health are compromised
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li7">
              <h3>
                <img
                  src="/assets/img/signal/hormonal_imbalance.png"
                  className="small_img"
                  alt=""
                />{" "}
                Hormonal Imbalance
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/hormonal_imbalance.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  EPLIMO screens thyroid, estrogen, testosterone, and cortisol
                  pathways to explain mood swings, low libido, or menstrual
                  issues
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li7">
              <h3>
                <img
                  src="/assets/img/signal/brain_fog.png"
                  className="small_img"
                  alt=""
                />{" "}
                Brain Fog &amp; Poor Focus
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/brain_fog.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  BDNF, COMT, and APOE variants plus metabolic data highlight
                  memory, focus, and cognitive vulnerabilities
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li9">
              <h3>
                {" "}
                <img
                  src="/assets/img/signal/inflammation.png"
                  alt="Inflammation"
                  className="small_img"
                />{" "}
                Joint Pain &amp; Inflammation
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/inflammation.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  We assess inflammatory genes (IL6, TNF), CRP levels, and detox
                  pathways to find the root cause of chronic pain
                </span>
              </div>
            </li>
            <li className="cs_case_study signals_ul_li10">
              <h3>
                <img
                  src="/assets/img/signal/blood_pressure.png"
                  className="small_img"
                  alt=""
                />{" "}
                Heart Risks &amp; Blood Pressure
              </h3>
              <div className=" right_hover_box">
                <img
                  src="/assets/img/signal/blood_pressure.jpg"
                  className="right_img img-fluid"
                  alt=""
                />
                <span>
                  EPLIMO screens lipid metabolism, blood pressure regulation
                  genes, and cardiovascular biomarkers to prevent future events
                </span>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </>
  );
}

export default Symptoms;
